import { useEffect, useRef, useState } from 'react'

export default function SkeletonLoader({ onDone }: { onDone: () => void }) {
  const [visible, setVisible] = useState(true)
  const onDoneRef = useRef(onDone)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    onDoneRef.current = onDone
  }, [onDone])

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setVisible(false)
      onDoneRef.current()
    }, 1500)
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [])

  if (!visible) return null

  return (
    <div className="skeleton-loader">
      <div className="skeleton-nav">
        <div className="skeleton skeleton-wide" />
        <div className="skeleton-nav-links">
          {[0, 1, 2, 3, 4].map((_, i) => (
            <div key={i} className="skeleton skeleton-medium" />
          ))}
        </div>
        <div className="skeleton skeleton-button" />
      </div>

      <div className="skeleton-hero">
        <div className="skeleton skeleton-img" />
        <div className="skeleton-content">
          <div className="skeleton skeleton-tagline" />
          <div className="skeleton skeleton-title" />
          <div className="skeleton skeleton-desc" />
          <div className="skeleton skeleton-button skeleton-btn-lg" />
        </div>
      </div>

      <div className="skeleton-sections">
        {[0, 1, 2].map((s) => (
          <div key={s} className="skeleton-section">
            <div className="skeleton skeleton-header" />
            <div className="skeleton-grid">
              {[0, 1, 2, 3].map((_, i) => (
                <div key={i} className="skeleton skeleton-card" />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
